export default {
  overlay: false,
  loader: false,
  loaderText: '',
  messages: []
}
